import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=b56838c6&scoped=true"
import script from "./Conversation.vue?vue&type=script&setup=true&lang=js"
export * from "./Conversation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=b56838c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56838c6",
  null
  
)

export default component.exports